import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { fuseAnimations } from '@fuse/animations';
import { ReviewService } from 'app/shared/services/review.service';
import { Subject } from 'app/shared/models/subject';
import { enumReviewStatus } from 'app/shared/models/review';
import { Assessment } from 'app/shared/models/assessment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'review-dialog',
  templateUrl: './review-dialog.component.html',
  styleUrls: ['./review-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class ReviewDialogComponent implements OnInit {

  action: enumReviewStatus;
  assessment: Assessment;
  title: string;
  subject: Subject;
  override = false;
  readOnly = false;
  saving = false;
  form: UntypedFormGroup;

  enumReviewStatus = enumReviewStatus;

  constructor(
    public dialogRef: MatDialogRef<ReviewDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private reviewService: ReviewService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    if (this.data && this.data.review){
      const review = this.data.review;
      this.action = review.status;
      this.override = review.override;
      this.subject = this.data.subject;
      this.assessment = this.data.assessment;
      this.readOnly = true;

      this.form = this.formBuilder.group({
        label: [review.label],
        comments: [review.comments],
        overrideReason: [review.overrideReason],
      });
    }
    else{
      this.action = this.data.action;
      this.assessment = this.data.assessment;
      this.override = this.data.override || false;
      this.subject = this.data.subject;

      this.form = this.formBuilder.group({
        label: ['', Validators.required],
        comments: [''],
        overrideReason: ['', (this.override ? Validators.required : null)],
      });
    }
    const subjectTypeName = (this.subject.isReferral && (this.subject.referral)) ? 'Referral' : this.subject.subjectType.name;
    this.title = `Review of ${subjectTypeName}: ${this.subject.summary}`; 
  }

  accept(){
    this.save(enumReviewStatus.Accepted);
  }

  reject(){
    this.save(enumReviewStatus.Rejected);
  }

  review(){
    this.save(enumReviewStatus.Reviewed);
  }

  save(status: enumReviewStatus){
    this.saving = true;
    const val = this.form.getRawValue();
    let overrideReason = '';
    if (this.override){
      overrideReason = val.overrideReason;
    }
    this.reviewService.addReview(this.subject, this.assessment, status, val.label, val.comments, this.override, overrideReason).pipe(take(1)).subscribe((subject) => {
      this.dialogRef.close({ data: { subject, action: this.action }});
    });
  }
}
